<script lang="ts" setup>
import { computed } from 'vue';
import { NotificationPatentFtoAnalysisCompletionType } from '@/types';
import CardTemplate from './card-template.vue';

interface Props {
  notification: NotificationPatentFtoAnalysisCompletionType;
  isUnread: boolean;
}

const props = defineProps<Props>();

const url = computed(() => {
  return `/patent-fto/analyses/${props.notification.patent_fto_analysis.id}`;
});

const analysisTitle = computed(() => {
  return `調査の実施が完了しました。「${props.notification.patent_fto_analysis.title}」`;
});
</script>
<template>
  <CardTemplate
    :type="notification.type"
    :url="url"
    :is-unread="isUnread"
    :created-at="notification.created_at"
    :content-title="analysisTitle"
  >
    特許調査エージェント
  </CardTemplate>
</template>
